import { VisionCalibration, type PublicSourceView, type VehicleClass } from '@urbanrats/contracts';

export function defaultCalibration(g: NonNullable<PublicSourceView['previewGeometry']>, classes: readonly VehicleClass[] = ['car', 'bus', 'truck', 'motorcycle']): VisionCalibration {
  return {
    calibrationVersion: 1,
    roi: g.roi,
    line: { lineId: 'line-1', a: g.line.a, b: g.line.b, countedDirection: g.line.countedDirection },
    includedClasses: [...classes],
    minConfidence: 0.35,
    hysteresis: 0.01,
    minDisplacement: 0.02,
    tracking: { highThresh: 0.5, lowThresh: 0.15, minHits: 3, maxAgeFrames: 15 },
    stride: 2,
  };
}

const KEY = (sourceId: string) => `urbanrats.calibration.v1.${sourceId}`;

/** DEMO convenience: calibrations live in this browser. In production they are operator-managed, audited records. */
export function loadCalibration(sourceId: string): VisionCalibration | null {
  try {
    const raw = localStorage.getItem(KEY(sourceId));
    if (!raw) return null;
    const r = VisionCalibration.safeParse(JSON.parse(raw));
    return r.success ? r.data : null;
  } catch {
    return null;
  }
}

export function saveCalibration(sourceId: string, c: VisionCalibration): void {
  try {
    localStorage.setItem(KEY(sourceId), JSON.stringify(c));
  } catch {
    /* demo convenience only */
  }
}
